import styled, { css } from 'styled-components';

import { IconButton as BaseIconButton } from './styled.base';

export * from './styled.base';

export const IconButton = styled(BaseIconButton)<{ disabled?: boolean }>`
  ${p =>
    p.disabled &&
    css`
      path {
        fill: ${Styles.color.grey.four};
      }
    `}
`;

export const fill = Styles.color.black;
